import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/ModalDownload.css";
import { useTranslation } from "react-i18next";


function DownloadModal({ show, onClose }) {
    const { t, i18n } = useTranslation();
  
  return (
    <div className="ModalWrap">
      <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
        <Modal.Header className="modalHeader">
          <Modal.Title className="ModalTitle">
            <span className="headerTittle">"Scanner Online"</span> {t("service-available")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <span>
            {t("service-message")}
          </span>
          <a href="/ScanOnlineSetup.zip" target="_blank" className="linkDownload">
            {t("download")} "Scanner Online"
          </a>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DownloadModal;
